<template>
  <div class="preview">
    <div v-click-outside="close" class="preview__content">
      <span @click="close" class="donation-bankaccount__close">&times;</span>
      <div>
        <div class="preview__label">
          <label>{{ label }}</label>
        </div>
        <div class="preview__preview">
          <img
            v-if="looading === true || iframeLoaded === false"
            :src="require('../assets/spinner.svg')"
          />
          <iframe @load="iframeHasLoaded" :src="link"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';

export default {
  name: 'Preview',

  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: {
    link: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'preview',
    },
  },

  data() {
    return {
      iframeLoaded: false,
    };
  },

  methods: {
    iframeHasLoaded() {
      this.iframeLoaded = true;
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.preview {
  position: fixed;
  height: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999;

  @media screen and (max-width: 800px) {
    max-width: 100vw;
  }

  &__content {
    height: 467px;
    background-color: #fff;
    margin: 20px auto;
    position: relative;
    width: 90%;
    width: 340px;
    border-radius: 8px;
    padding: 16px 16px 26px 16px;

    @media screen and (max-width: 800px) {
      max-width: 90vw;
      margin: 50px auto;
    }
  }
  &__spinner {
    background-image: url('../assets/spinner.svg') !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: contain !important;
    font-size: 0 !important;
    margin: 25px 0;
    img {
      margin-left: auto;
      margin-right: auto;
      width: 45px;
    }
  }
  &__close {
    color: #000;
    position: absolute;
    top: 0;
    right: 15px;
    font-size: 28px;
    cursor: pointer;
  }

  &__preview {
    iframe {
      height: 400px;
      width: 100%;
    }
    img {
      position: fixed;
      top: 50%;
      left: 50%;
      margin-top: -100px;
      margin-left: -100px;
    }
  }
}
</style>
